import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { Fragment } from 'react';

const Header: React.FC = () => {
  const handleActionClick = (action: string) => {
    alert(`${action} - Coming Soon!`);
  };

  return (
    <header className="bg-gradient-to-r from-primary-900 to-primary-800 text-white">
      <div className="container mx-auto px-4 py-6">
        <nav className="flex flex-col md:flex-row justify-between items-center">
          <Link to="/" className="text-2xl mb-4 md:mb-0">
            <span className="font-bold">Eigen</span>
            <span className="font-normal">surance</span>
          </Link>
          
          <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-8">
            <div className="space-x-6">
              <Link to="/security" className="hover:text-primary-200">Security</Link>
              <Link to="/validator-guide" className="hover:text-primary-200">Validator Guide</Link>
              <Link to="/market-making" className="hover:text-primary-200">Market Making</Link>
              <Link to="/risk-models" className="hover:text-primary-200">Risk Models</Link>
              <a 
                href="https://andrewgao.notion.site/Eigensurance-19b2c6cd89ad80bfb392e2809af25e71?pvs=74" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-primary-200"
              >
                Whitepaper
              </a>
            </div>
            
            <Menu as="div" className="relative inline-block text-left">
              <Menu.Button className="inline-flex items-center justify-center bg-white text-primary-900 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-primary-50 transition-colors">
                Contribute
                <ChevronDownIcon className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" />
              </Menu.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="px-1 py-1">
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={() => handleActionClick('Submit Models')}
                          className={`${
                            active ? 'bg-primary-100' : ''
                          } group flex w-full items-center rounded-md px-2 py-2 text-sm text-primary-900`}
                        >
                          Submit Models
                        </button>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={() => handleActionClick('Become a Validator')}
                          className={`${
                            active ? 'bg-primary-100' : ''
                          } group flex w-full items-center rounded-md px-2 py-2 text-sm text-primary-900`}
                        >
                          Become a Validator
                        </button>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={() => handleActionClick('Become an Operator')}
                          className={`${
                            active ? 'bg-primary-100' : ''
                          } group flex w-full items-center rounded-md px-2 py-2 text-sm text-primary-900`}
                        >
                          Become an Operator
                        </button>
                      )}
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header; 